<template>
    <v-container class="white mt-5">
    
        <div>
            <p> {{ $t('profile.title') }} </p>
        </div>
    
        <v-row class="mb-4 ml-2" align="center">
            <image-input v-model="avatar" fieldName="avatar" @input="uploadImage"  class="mr-4">
                <div slot="activator">
                <v-avatar size="150px" v-ripple v-if="!avatar || !avatar.imageURL" class="grey lighten-3 mb-3">
                    <span>{{ $t('common.change_avatar') }}</span>
                </v-avatar>
                <v-avatar size="150px" v-ripple v-else class="mb-3">
                    <img :src="avatar.imageURL" alt="avatar">
                </v-avatar>
                </div>
            </image-input>

            <v-rating v-model="rating"
                color="yellow darken-3"
                background-color="grey darken-1"
                empty-icon="$ratingFull"
                half-increments
                large
                readonly
            ></v-rating>
        </v-row>

        <!-- <v-row class="mb-4 ml-4">
            <v-slide-x-transition>
                <div v-if="avatar && saved == false">
                    <v-btn class="primary" @click="uploadImage" :loading="saving">Save Avatar</v-btn>
                </div>
            </v-slide-x-transition>
        </v-row> -->

        <v-row>
            <v-col cols="12" sm="6">
                <v-text-field v-model="profile.email" v-bind:label="$t('profile.email')" outlined readonly></v-text-field>
            </v-col>

            <v-col cols="12" sm="6">
                <v-text-field v-model="profile.nickname" v-bind:label="$t('profile.nickname')" outlined readonly></v-text-field>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12" sm="6">
                <v-text-field v-model="profile.fullname" :rules="stringRules" v-bind:label="$t('profile.fullname')" v-bind:placeholder="$t('profile.fullname')" value="Nguyễn Văn A" outlined></v-text-field>
            </v-col>
    
            <v-col cols="12" sm="6">
               <!-- <v-text-field  v-model="date" type="date" v-bind:label="$t('profile.birthday')" outlined ></v-text-field> -->
               <v-dialog ref="dialog" v-model="modal" :return-value.sync="date" persistent width="290px">
                    <template v-slot:activator="{ on }">
                        <v-text-field v-model="computedDateFormatted" v-bind:label="$t('profile.birthday')" readonly v-on="on" outlined></v-text-field>
                    </template>
                    <v-date-picker v-model="date" scrollable locale="vi">
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="modal = false"> {{ $t('common.cancel') }} </v-btn>
                        <v-btn text color="primary" @click="$refs.dialog.save(date)"> {{ $t('common.ok') }} </v-btn>
                    </v-date-picker>
                </v-dialog>
            </v-col>
    
            <v-col cols="12" sm="6">
                <v-text-field v-model="profile.phone" :rules="phoneRules" v-bind:label="$t('profile.phone')" outlined></v-text-field>
            </v-col>
    
            <v-col cols="12" sm="6">
                <v-text-field v-model="profile.identify" :rules="identifyRules" v-bind:label="$t('profile.identify')"  outlined></v-text-field>
            </v-col>
            
            <v-col cols="12" sm="4">
                <v-autocomplete v-model="selectProvince" :items="provinces" item-text="province_name" v-bind:label="$t('profile.province')" outlined return-object></v-autocomplete>
            </v-col>

            <v-col cols="12" sm="4">
                <v-autocomplete v-model="selectDistrict" :items="districts" item-text="district_name" v-bind:label="$t('profile.district')" outlined return-object></v-autocomplete>
            </v-col>

            <v-col cols="12" sm="4">
                <v-autocomplete v-model="selectWard" :items="wards" item-text="wards_name" v-bind:label="$t('profile.ward')" outlined return-object></v-autocomplete>
            </v-col>

            <v-col cols="12" sm="6">
                <v-text-field v-model="address" :rules="addressRules" v-bind:label="$t('profile.address')" outlined></v-text-field>
            </v-col>

            <v-col cols="12" sm="12">
                <v-text-field v-model="job" v-bind:label="$t('job_management.role')"  outlined readonly></v-text-field>
            </v-col>

            <v-col cols="12" sm="12">
                <v-text-field v-model="contextPath" v-bind:label="$t('job_management.context')"  outlined readonly></v-text-field>
            </v-col>            
        </v-row>

        <v-row>
            <v-col cols="12" sm="3" class="mr-auto">
                <v-btn large block color="primary" class="normal-button" @click="updateInfor"> {{ $t('profile.btn_title') }} </v-btn>
            </v-col>
        </v-row>
    
    </v-container>
</template>

<script>
import VueJwtDecode from 'vue-jwt-decode';
import moment from 'moment';
import i18n from '@/plugins/i18n';
import ImageInput from '@/components/ImageInput.vue';

export default {
    data: () => ({
        baseImage: process.env.VUE_APP_BASE_IMAGE,
        baseAttach: process.env.VUE_APP_BASE_ATTACH,
        avatar: {},
        // saving: false,
        // saved: false,
        rating: 0,
        date: '',
        modal: false,

        selectProvince: null,
        selectDistrict: null,
        selectWard: null,

        contextPath: '',
        job: '',
        address: '',
        provinces: [
        ],
        districts: [
        ],
        wards: [
        ],
        profile: {},

        firstEdit: true,

        stringRules: [
          v => !!v || i18n.t('validate.not_empty'),
        //   v => (v && v.length > 5) || i18n.t('validate.string_invalid')
        ],
        identifyRules: [
          v => (v && v.length > 8) || i18n.t('validate.indentify_invalid')
        ],
        phoneRules: [
            v => !!v || i18n.t('validate.not_empty'),
            v => (v && v.length > 9) || i18n.t('validate.phone_invalid'),
        ],
        addressRules: [
            v => !!v || i18n.t('validate.not_empty'),
            v => (v && v.length > 2) || i18n.t('validate.address_invalid'),
        ],
        emailRules: [
            v => !!v || i18n.t('validate.email_require'),
            v => /.+@.+\..+/.test(v) || i18n.t('validate.email_invalid'),
        ],
        passdRules: [
            v => !!v || i18n.t('validate.password_require'),
            v => (v && v.length > 5) || i18n.t('validate.password_invalid'),
        ],
    }),

    components: {
       ImageInput: ImageInput
    },

    watch: {
        selectProvince (val) {
            if (!this.firstEdit) {
                this.selectWard = null;
            }

            if (val && val.province_id) {
                this.getDistrictByProvinceID(val.province_id);
            } 
        },

        selectDistrict (val) {
            if (val && val.district_id) {
                this.getWardByDistrictID(val.district_id);
            }
        },

        avatar: {
            handler: function() {
                this.saved = false
            },
            deep: true
        }
    },

    computed: {
      computedDateFormatted () {
        return this.formatDate(this.date)
      },
    },

    async created () {
        await this.getProvince();    
        await this.getProfile();
    },


    methods: {
        launchFilePicker(){
            this.$refs.file.click();
        },

        formatDate (date) {
            if (!date) {
                return null
            }

            const [year, month, day] = date.split('-')
            return `${month}/${day}/${year}`
        },

        async getProvince() {
            try {
                // const response =  await this.$http.get('/province');
                const response =  await this.$http.get(process.env.VUE_APP_VT_PROVINCE_API);
                if (response.data && response.data.success) {
                    this.provinces = response.data.data;
                    // if (!this.firstEdit) {
                    //     this.selectProvince = this.provinces[0];
                    // }
                }
            } catch(e) {
                console.log(e.stack);
            }
        },

        async getDistrictByProvinceID(provinceId) {
            try {
                // const response =  await this.$http.get('/province/province/' + provinceId);
                const response =  await this.$http.get(process.env.VUE_APP_VT_DISTRICT_API + provinceId);
                if (response.data && response.data.success) {
                    this.districts = response.data.data;
                }
            } catch(e) {
                console.log(e.stack);
            }
        },

        async getWardByDistrictID(districtId) {
            try {
                // const response =  await this.$http.get('/province/province/' + provinceId);
                const response =  await this.$http.get(process.env.VUE_APP_VT_WARD_API + districtId);
                if (response.data && response.data.success) {
                    this.wards = response.data.data;
                }
            } catch(e) {
                console.log(e.stack);
            }
        },

        async getFullInfoByWardId(wardId) {
            if (!wardId) {
                return;
            }

            try {
                // const response =  await this.$http.get('/province/province/' + provinceId);
                const response =  await this.$http.get(process.env.VUE_APP_VT_FULL_INFO_API + wardId);
                if (response.data && response.data.success) {
                    this.selectProvince = response.data.data.province;
                    this.selectDistrict = response.data.data.district;
                    this.selectWard = response.data.data.ward;

                    setTimeout(() => {this.firstEdit = false}, 1000);
                }
            } catch(e) {
                console.log(e.stack);
            }
        },

        async getProfile() {
            const dataUser = VueJwtDecode.decode(localStorage.getItem('access_token'));
            try {
                const response = await this.$http.get(`${process.env.VUE_APP_GET_USER_URL}/${dataUser.data._id}`);
                if (response.data && response.data.success) {
                    this.profile = response.data.data;
                    this.date = moment(String(this.profile.birthday)).format("YYYY-MM-DD");
                    
                    console.log(this.profile)
                    if (this.profile.address && this.profile.address.ward) {
                        this.address = this.profile.address.detail;
                        this.getFullInfoByWardId(this.profile.address.ward);
                    }

                    if (this.profile.avatar) {
                        this.avatar.imageURL = this.baseImage + this.profile.avatar;
                    }

                    if (this.profile.count_rate > 0) {
                        this.rating = (this.profile.total_rate  / this.profile.count_rate) / 2.0
                    } else {
                        this.rating = 0;
                    }

                    this.getPathJob(this.profile.job);
                }
            } catch (e) {
                console.log(e.stack);
            }
        },

        async updateInfor() {
            if (!this.profile.fullname || this.profile.fullname.length == 0) {
                alert(i18n.t('validate.infor_empty'));
                return;
            }

            if (!this.profile.phone || this.profile.phone.length == 0) {
                alert(i18n.t('validate.infor_empty'));
                return;
            }

            if (!this.profile.email || this.profile.email.length == 0) {
                alert(i18n.t('validate.infor_empty'));
                return;
            }

            if (!this.profile.nickname || this.profile.nickname.length == 0) {
                alert(i18n.t('validate.infor_empty'));
                return;
            }

            if (!this.profile.identify || this.profile.identify.length == 0) {
                alert(i18n.t('validate.infor_empty'));
                return;
            }

            if (!this.date) {
                alert(i18n.t('validate.infor_empty'));
                return;
            }

            if (!this.selectWard) {
                alert(i18n.t('validate.ward_empty'));
                return;
            }

            console.log(this.profile.fullname)

            const self = this;
            const requestInfor = {
                fullname : self.profile.fullname,
                identify : self.profile.identify,
                phone : self.profile.phone,
                nickname: self.profile.nickname
            }
            requestInfor.birthday = moment(String(self.date)).format("DD/MM/YYYY");

            console.log(requestInfor)
            const response = await this.$http.put('/user/' + self.profile._id, requestInfor);
            if (response.data && response.data.success) {
                console.log(response);
                // this.$fire({
                //     title: i18n.t('common.update_success'),
                //     text: "",
                //     type: "success"
                // });
            }

            const fullDetail = self.address + ", " + self.selectWard.wards_name + ", " + self.selectDistrict.district_name 
                              + ", " + self.selectProvince.province_name
            const requestBody = {
                name : self.profile.fullname,
                uid : self.profile._id,
                detail : self.address,
                ward : self.selectWard.wards_id,
                fullDetail: fullDetail
            };

            try {
                let response = '';
                if (self.profile.address && self.profile.address.detail) {
                    response =  await this.$http.put(process.env.VUE_APP_ADDRESS_API + self.profile.address._id, requestBody);
                } else {
                    response =  await this.$http.post(process.env.VUE_APP_ADDRESS_API, requestBody);
                }
                
                if (response.data && response.data.success) {
                    this.$fire({
                        title: i18n.t('common.update_success'),
                        text: "",
                        type: "success"
                     });
                } else if(!response.data.success) {
                    alert(i18n.t(response.data.message));
                } else {
                    alert(i18n.t('validate.request_error'));
                }  
            } catch(e) {
                console.log(e.stack);
                alert(i18n.t('validate.request_error'));
            }
        },

        async uploadImage() {
            this.saving = true
            if (this.avatar.formData != null) {
                const response =  await this.$httpUpload.post("/user/avatar/", this.avatar.formData);
                if (response.data && response.data.success) {
                    setTimeout(() => this.savedAvatar(), 1000)
                } else {
                    alert(i18n.t('validate.request_error'));
                }
            }
        },

        savedAvatar() {
            this.$route.go()
        },

        getPathJob(job) {
            if (!job || !job.context) {
                this.job = '';
                this.contextPath = '';
            } else {
                if (job.context.parents && job.context.parents.length > 0) {
                    if (job.context.parents.length == 2) {
                        this.contextPath = job.context.parents[0].name + "/" + job.context.parents[1].name + "/" + job.context.name;
                    } else {
                        this.contextPath = job.context.parents[0].name + "/" + job.context.name;
                    }
                } else {
                    this.contextPath = job.context.name;
                }

                this.job = job.title;
            }
        },
    }
}
</script>

<style scoped>
p {
    color: #1D243E;
    font-style: normal;
    font-weight: bold;
    font-size: 24px;
    padding-top: 20px;
}
</style>